import React, { useState, useEffect } from "react";
import { Clock } from "lucide-react";
import { formatTime, calculateSpentTime } from "../Pages/utils/taskUtils";

const TaskTimer = ({ timeline }) => {
  const [, tick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      tick((p) => p + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const { totalMs, isRunning } = calculateSpentTime(timeline);

  if (!timeline?.length) {
    return <div className="flex-1 text-gray-400">-</div>;
  }

  return (
    <div className="text-[12px] sm:text-[14px] text-gray-600 flex items-center gap-1 whitespace-nowrap">
      <span className="flex gap-1 items-center">
        <Clock size={15} />
        {formatTime(totalMs)}
      </span>

      {isRunning && (
        <span className="text-green-600 text-xs animate-pulse">● Running</span>
      )}
    </div>
  );
};

export default TaskTimer;
